<template>
  <div class="notifications" v-if="latestLog">
    <b-alert :show="dismissCountDown" :fade="true" dismissible :variant="variant" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
      <p>{{latestLog.message}}</p>
      <p v-if="latestLog.errors">
        <span v-for="(error, key) in latestLog.errors" :key="key">
          <small>{{error[0]}}</small><br>
        </span>
      </p>
      <b-progress :variant="variant" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress>
    </b-alert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'notifications',
  data () {
    return {
      dismissSecs: 4,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  computed: {
    ...mapGetters(
      'app',
      [
        'latestLog'
      ]
    ),
    variant () {
      let v = 'info'

      if (this.latestLog) {
        if (this.latestLog.type === 'error') {
          v = 'danger'
        } else if (this.latestLog.type === 'success') {
          v = 'success'
        }
      }

      return v
    }
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  },
  watch: {
    latestLog () {
      this.showAlert()
    }
  }
}
</script>

<style scoped lang="scss">
  .notifications {
    position: fixed;
    top: 60px;
    right: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Notifications.vue